import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
// import { Link } from "react-router-dom";
import Box from "@mui/material/Box";

import styles from "./Manage.module.css";
// import ActionButton from "../../components/ActionButton";
import FileCard from "../../components/fileCard/FileCard";
import PageHeader from "../../components/PageHeader";
import Loading from "../../components/Loading";
import { apiUrl } from "../../utils/variables";
// import useFirebaseAuth from "../../hooks/useFirebaseAuth";

const Files = () => {
  const token = useSelector((state) => state.auth.token);
  // const { token } = useFirebaseAuth();
  const [allFiles, setAllFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const handleDelete = async (fileId) => {
    // console.log(token);
    try {
      const resp = await fetch(`${apiUrl}/documents/${fileId}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const result = await resp.json();
      if (result === true) {
        Swal.fire("Success", "Document has been deleted", "success");
        setAllFiles(allFiles.filter((file) => file.id !== fileId));
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const getAllFiles = async () => {
      try {
        const resp = await fetch(`${apiUrl}/documents/`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (resp.status === 401) {
          return Swal.fire(
            "Error",
            "Sorry for the inconvenience. Please log in again",
            "error"
          );
        } else {
          Swal.close();
        }

        const filesArr = await resp.json();
        filesArr.sort((a, b) => {
          if (a.lastEdited > b.lastEdited) return -1;
          if (a.lastEdited < b.lastEdited) return 1;
          return 0;
        });
        // console.log("filesArr", filesArr);
        setIsLoading(false);
        setAllFiles(filesArr);
      } catch (error) {
        console.log(error.message);
        Swal.fire(
          "Error",
          "There was an error with getting your files",
          "error"
        );
      }
    };

    getAllFiles();
  }, [token]);

  const handleMainDisplay = () => {
    if (isLoading) {
      return <Loading />;
    }

    if (!allFiles.length) {
      return null;
    }

    return allFiles?.map((file) => {
      const { id, fileName, lastEdited, createdBy } = file;
      return (
        <FileCard
          key={id}
          fileId={id}
          fileName={fileName}
          editDate={lastEdited}
          createdBy={createdBy.userName}
          action={handleDelete}
        />
      );
    });
  };

  return (
    <>
      <PageHeader sx={{ display: "flex", justifyContent: "space-between" }}>
        <h1>Your Files</h1>
      </PageHeader>

      <Box>
        {/* <Box>
          <h2 className={styles.collectionName}>Recent</h2>
          <Box sx={{display: "flex"}}>
            {[1, 2, 3, 4].map(file => {
              return (<FileCard 
                fileName="Sample_File"
                fileSize="14.99 kb"
                createdBy=""
                rows="50"
                columns="50"
                tests="50"
              />)
            })}
          </Box>
        </Box> */}

        <Box>
          <h2 className={styles.collectionName}>All Files</h2>
          <Box sx={{ display: "flex", flexWrap: "wrap" }}>
            {handleMainDisplay()}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Files;
